import styled from 'styled-components';
import { NavTabsList, NavTabTrigger } from 'ui/tabsGroup';
import { Link } from 'ui/links';
import { Body2, borderRadius, colors, fontWeights, spacing, subtleShadow } from 'ui/theme';

export const Wrapper = styled.div`
  ${borderRadius.xl};
  ${subtleShadow};
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
  border-bottom: ${spacing.single} solid ${colors.grey15};
  width: 100%;
`;

export const StyledNavTabsList = styled(NavTabsList)`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding: ${spacing.half} ${spacing.plusHalf} ${spacing.threeQuarter} ${spacing.plusHalf};
`;

export const StyledNavTrigger = styled(NavTabTrigger)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};
  width: 100%;
`;

export const LinkNav = styled(Link)`
  align-items: center;
  display: inline-flex;
  border: none;
`;

export const ButtonText = styled(Body2)`
  font-weight: ${fontWeights.semiBold};
  color: inherit;
`;
